import { render } from "./BrLogin.vue?vue&type=template&id=7c3e534a&scoped=true"
import script from "./BrLogin.vue?vue&type=script&lang=js"
export * from "./BrLogin.vue?vue&type=script&lang=js"

import "./BrLogin.vue?vue&type=style&index=0&id=7c3e534a&lang=scss&scoped=true"
import "./BrLogin.vue?vue&type=style&index=1&id=7c3e534a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3e534a"]])

export default __exports__